function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { v4 as uuidv4 } from 'uuid';
import { uploadFileS3 } from "../utils/uploadFilesAWS";
export const saveFileInAwsAndSendMessage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (_ref, message, socket) {
    let type = _ref.type,
        content = _ref.content;

    if (type === 'album') {
      const urlImages = [];
      Promise.all([yield content.forEach( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(function* (image, index) {
          yield uploadFileS3(image?.file, "".concat(uuidv4(), ".").concat(image?.extension || image?.name.split('.').pop()), 'album', url => {
            try {
              urlImages.push({
                content: url,
                type: 'image'
              });

              if (index === content.length - 1) {
                message.content = JSON.stringify(urlImages);
                socket.emit('private_message', message);
              }
            } catch (error) {
              throw error;
            }
          });
        });

        return function (_x4, _x5) {
          return _ref3.apply(this, arguments);
        };
      }())]);
    } else if (type === 'file') {
      yield uploadFileS3(content?.file, "".concat(uuidv4(), ".").concat(content?.extension || content?.name.split('.').pop()), type, /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(function* (url) {
          try {
            message.content = JSON.stringify({
              name: content?.name.split('.')[0],
              extension: content?.extension,
              url
            });
            socket.emit('private_message', message);
          } catch (error) {
            throw error;
          }
        });

        return function (_x6) {
          return _ref4.apply(this, arguments);
        };
      }());
    } else {
      yield uploadFileS3(content?.file, "".concat(uuidv4(), ".").concat(content?.extension || content?.name.split('.').pop()), type, url => {
        try {
          message.content = url;
          socket.emit('private_message', message);
        } catch (error) {
          throw error;
        }
      });
    }
  });

  return function saveFileInAwsAndSendMessage(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();